import { useState } from 'react';

// eslint-disable-next-line import/prefer-default-export
export function Pagination() {
  const [pagination, setPagination] = useState(1);

  const changedPagination = (e, value) => {
    setPagination(value);
  };

  return {
    pagination,
    changedPagination,
  };
}
